import {find} from 'lodash';

const cardStatusMixin = {
    computed: {
        statusInfoList() {
            return this.store.statusDatasource.reduce((accumulation, item) => {
                accumulation[item.value] = {
                    text: item.label,
                    class: this.getStatusClass(item.value) || ''
                };
                return accumulation;
            }, {});
        }
    },
    methods: {
        getTip(item) {
            const phase = item.status.match(/^(\w+?)(_|$)/);
            const text = find(
                this.store.statusDatasource,
                ele => ele.value === item.status
            ).label;
            switch (phase[1]) {
                case 'DESIGN':
                    return [`设计审核：${text.slice(2)}`];
                case 'PRODUCT':
                    return ['设计审核：已通过', `物料审核：${text.slice(2)}`];
                default:
                    return [];
            }
        },
        getStatusClass(status) {
            switch (status) {
                case 'ONLINE':
                case 'WAIT_FOR_LAUNCH':
                case 'DESIGN_REVIEW_PASSED':
                case 'PRODUCT_REVIEW_PASSED':
                    return 'text-success';
                case 'DESIGN_REVIEW_FAILED':
                case 'PRODUCT_REVIEW_FAILED':
                    return 'text-danger';
                case 'DRAFT':
                case 'DESIGN_REVIEWING':
                case 'PRODUCT_REVIEWING':
                case 'OFFLINE':
                    return 'text-disable';
                default:
                    return '';
            }
        }
    }
};

export default cardStatusMixin;